import React from 'react';
export function HeroSection() {
  return <section className="bg-hero-radial pt-6 px-5 pb-6 text-center relative overflow-hidden" data-id="element-92">
      <div className="absolute top-[-50%] left-[-50%] w-[200%] h-[200%] bg-hero-glow animate-rotate-glow pointer-events-none" data-id="element-93"></div>

      <div className="max-w-[850px] mx-auto relative z-10" data-id="element-94">
        <div className="inline-block bg-gradient-teal text-negro py-1 px-4 rounded-full text-[11px] font-bold tracking-[2px] uppercase mb-2" data-id="element-95">
          💎 EL PACK MÁS COMPLETO DE CHOCOLATERÍA DE ARGENTINA
        </div>

        <h1 className="font-playfair text-[clamp(20px,3.8vw,40px)] font-black leading-[1.12] mb-2 text-blanco" data-id="element-96">
          Seguí este Sistema de 3 Pasos y en tu Primer Mes Vas a Tener
          <span className="text-dorado block" data-id="element-97">
            Chocolates con Brillo de Joyería,
          </span>
          un Instagram que Vende Solo y tu Primera Caja Vendida a
          <span className="text-teal" data-id="element-98"> Precio Premium</span>
        </h1>

        <div className="max-w-[280px] mx-auto mb-2 relative" data-id="element-99">
          <img src="https://cdn.magicpatterns.com/uploads/sryNKrCfe3FkFSRPjxP2e7/la_misma_imagen_202604231344.jpg" alt="EFECTO DIAMANTE — Pack Completo" className="w-full rounded-2xl drop-shadow-[0_20px_40px_rgba(201,149,108,0.4)] transition-transform duration-300 hover:scale-[1.02]" data-id="element-100" />
        </div>

        <p className="text-[clamp(13px,1.8vw,16px)] text-oro-rosa-claro max-w-[700px] mx-auto mb-3 leading-[1.5] italic" data-id="element-101">
          El único método diseñado para el mercado argentino que te lleva de
          cero a tu primera venta real en menos de 30 días — Garantizado o te
          devolvemos cada peso
        </p>

        <a href="#comprar" onClick={e => {
        e.preventDefault();
        document.getElementById('comprar')?.scrollIntoView({
          behavior: 'smooth'
        });
      }} className="inline-block bg-gradient-cta text-negro py-3 px-8 rounded-[60px] text-[clamp(15px,2vw,18px)] font-black no-underline tracking-[1px] transition-all duration-400 shadow-[0_15px_40px_rgba(212,175,55,0.4)] animate-pulse-cta uppercase cursor-pointer border-none hover:-translate-y-[3px] hover:scale-[1.03]" data-id="element-102">
          💎 QUIERO MI EFECTO DIAMANTE AHORA
        </a>

        <div className="mt-2 text-[12px] text-[#888] flex justify-center items-center gap-3 flex-wrap" data-id="element-103">
          <span className="flex items-center gap-1" data-id="element-104">🔒 Pago 100% Seguro</span>
          <span className="flex items-center gap-1" data-id="element-105">⚡ Acceso Inmediato</span>
          <span className="flex items-center gap-1" data-id="element-106">🛡️ Garantía 30 Días</span>
          <span className="flex items-center gap-1" data-id="element-107">💳 Hasta 6 cuotas</span>
        </div>
      </div>
    </section>;
}